import React, { type HTMLAttributes } from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';
import { Container, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { Paragraph, Block } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Button, Hero, WysiwygField } from '../../../../components';
import type { NodeHomePage as Type } from '../../../../types/uncinc_profile/nodes';

import { APP_OPTIONS, SCREEN_TABLET } from '../../../../config/constants';
import usePhaseState from '../../../../helpers/usePhaseState';

import './style.scss';


interface HomePageProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const NodeHomePageAppeltjes: React.FC<HomePageProps> = ({
  entity,
  className,
}) => {
  const classes = classNames(className, 'NodeHomePageAppeltjes');
  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_TABLET;
  const homePage = entity.toJS();
  const phase = usePhaseState();
  const title = homePage.title[0].value;
  const body = homePage.body[0]?.processed;
  const primaryLink = homePage.field_link[0];
  const secondaryLink = homePage.field_link_secondary[0];
  const paragraphs = homePage.field_paragraphs;
  const media = homePage.field_media_item[0];

  const { bundle } = media;
  let image = null;
  let videoMobile = null;
  let video = null;
  if (bundle === 'image') {
    image = media;
  } else if (bundle === 'video_file' && isMobile && media.entity.field_media_video_file_mobile.length > 0) {
    videoMobile = media.entity.field_media_video_file_mobile;
  } else {
    video = media;
  }

  return (
    <article typeof="schema:WebPage" className={classes}>
      <Hero
        image={image}
        video={video}
        mobileVideo={videoMobile ? videoMobile[0] : null}
        className="Hero__hero"
      >
        <Container>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1">
              <h1 className="Hero__wrapper__title">{title}</h1>
              {body && (
                <WysiwygField
                  property="schema:text"
                  className="Hero__wrapper__body"
                  html={body}
                />
              )}
              <div className="Hero__wrapper__links">
                {primaryLink && (
                  <Button withIcon buttonIcon primary href={primaryLink.uri} className="Hero__wrapper__links__primaryButton">
                    {primaryLink.title}
                  </Button>
                )}
                {secondaryLink && (
                  <Button withIcon buttonIcon primary href={secondaryLink.uri} className="Hero__wrapper__links__secondaryButton">
                    {secondaryLink.title}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </Container>
      </Hero>

      <div className="Paragraphs NodeHomePageAppeltjes__paragraphs">
        <Container>
          <div className="row">
            <div className="col-12 col-lg-8 offset-lg-2 col-md-8 offset-md-2">
              <Block id={APP_OPTIONS.parameters.avoBlockIds[phase]} />
            </div>
          </div>
        </Container>
        {paragraphs.length > 0 && paragraphs.map((paragraph) => {
          const targetId = paragraph.target_id;

          return (
            <Paragraph
              key={`paragraph:${targetId}`}
              id={targetId}
              entity={Immutable.fromJS(paragraph.entity)}
            />
          );
        })}
      </div>
    </article>
  );
};

export default NodeHomePageAppeltjes;
